import { Directive, ElementRef, OnDestroy, AfterViewInit } from '@angular/core';

declare var $: any;

@Directive({
	selector: '[appTooltip]'
})
export class TooltipDirective implements AfterViewInit, OnDestroy {
	constructor(private el: ElementRef) {}

	ngAfterViewInit() {
		$(this.el.nativeElement).tooltip();
	}

	ngOnDestroy() {
		$(this.el.nativeElement).tooltip('dispose');
	}
}
